import * as React from 'react';
import { styled } from '@mui/material/styles';
import { Grid } from '@mui/material';

const CssGrid = styled(Grid)({

    '&.MuiGrid-root': {
        paddingRight: 16,
        paddingBottom: 16,
        marginLeft: "auto",
        marginRight: "auto",
        width: '100%'
    },
});

export default function StyledGrid(props: {
    spacing?: number,
    children?: React.ReactNode,
    container?: boolean
    boxShadow?: number
}) {
    return (

        <CssGrid
            container={props.container}
            spacing={props.spacing}
            boxShadow={props.boxShadow}
        >
            {props.children}

        </CssGrid>

    );
}